import { NgModule } from "@angular/core";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AuthConfig, AuthConfigService, AuthModule as Auth0Module } from "@auth0/auth0-angular";
import { Configuration, configurationToken } from "../../configuration";
import { EffectsModule } from "@ngrx/effects";
import { AuthEffects } from "./store/effects";
import { Http401Interceptor } from "./interceptors/http401.interceptor";

@NgModule({
    imports: [EffectsModule.forFeature([AuthEffects]), Auth0Module.forRoot()],
    providers: [
        {
            provide: AuthConfigService,
            // Loaded before bootstrap; available even when effects instantiate Auth0 early.
            useFactory: (configuration: Configuration): AuthConfig => ({
                domain: configuration.authDomain,
                clientId: configuration.authClientId,
                cacheLocation: "localstorage",
            }),
            deps: [configurationToken],
        },
        { provide: HTTP_INTERCEPTORS, useClass: Http401Interceptor, multi: true },
    ],
})
export class ApplicationAuthModule {}
